$base = require './model.base'

module.exports = do ->
  return RowDetail: $base.RowDetail
